import { render, staticRenderFns } from "./TitlePageIndex.vue?vue&type=template&id=1e0b8ae0"
import script from "./TitlePageIndex.vue?vue&type=script&lang=ts"
export * from "./TitlePageIndex.vue?vue&type=script&lang=ts"
import style0 from "./TitlePageIndex.vue?vue&type=style&index=0&id=1e0b8ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports